/**
 * Curriculum Vitae Detail Formatter.
 */
window.curriculumVitaeDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += row.description;
    }
    return html;
};
